export const locales = {
	homeLinkPrefix: 'Accueil,',
	logoCnam: 'Caisse nationale',
	logoAmeli: 'ameli.fr',
	logoAmeliPro: 'AmeliPro',
	logoCompteAmeli: 'Compte ameli',
	compteEntreprise: {
		title: {
			text: 'Compte',
			highlight: 'entreprise'
		},
		subTitle: 'Vos démarches maladie et risques professionnels'
	}
};
